module.exports = __webpack_public_path__ + "img/ring_g_o_null_null@3x.1e572dd0.png";